(function () {
  'use strict';
  var timer;
  function refreshSalesBadges() {
    window.clearTimeout(timer);
    var now = Date.now();
    var nextExpiry = Infinity;
    document.querySelectorAll('.ec-browse-catalog [data-ec-sales-expiry], .ec-gift-shelf [data-ec-sales-expiry]').forEach(function (badge) {
      // Theme copies use the same shop-validated sales snapshot; theme IDs change on duplication.
      // The Liquid feed validates source and freshness; the client enforces expiry only.
      var startText = badge.getAttribute('data-ec-sales-start');
      var endText = badge.getAttribute('data-ec-sales-expiry');
      var start = Number(startText) * 1000;
      var end = Number(endText) * 1000;
      if (!/^\d+$/.test(startText || '') || !/^\d+$/.test(endText || '') ||
          !Number.isFinite(start) || !Number.isFinite(end) || start <= 0 ||
          end <= start || now < start || now >= end) {
        badge.hidden = true;
        return;
      }
      badge.hidden = false;
      nextExpiry = Math.min(nextExpiry, end);
    });
    if (nextExpiry !== Infinity) {
      timer = window.setTimeout(refreshSalesBadges, Math.min(2147483647, Math.max(100, nextExpiry - now + 100)));
    }
  }
  function initialize() {
    refreshSalesBadges();
    document.querySelectorAll('.ec-browse-catalog, .ec-gift-shelf').forEach(function (catalog) {
      new MutationObserver(refreshSalesBadges).observe(catalog, {childList: true, subtree: true});
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
  document.addEventListener('visibilitychange', refreshSalesBadges);
  window.addEventListener('pageshow', refreshSalesBadges);
})();
